import React from 'react';
import { FeaturesAndCapabilitiesResponsePayloadService } from '../../@types/dataTypes';
import FeaturesAccordionItem from '../featuresAccordionItem/FeaturesAccordionItem';
import _ from 'lodash';
import { servicesToDisplay } from '../../tools/tools';
import { VinCheckerCSFeaturesLabels } from '../../@types/labelTypes';

type FeaturesAccordionProps = {
	features: FeaturesAndCapabilitiesResponsePayloadService[];
	labels: VinCheckerCSFeaturesLabels;
};
export default function FeaturesAccordion({
	features,
	labels
}: FeaturesAccordionProps): React.JSX.Element {
	return (
		<>
			{_.map(servicesToDisplay(features), (feature) => {
				return (
					<FeaturesAccordionItem
						service={feature}
						labels={labels}
						key={`${feature.serviceName}-accordion-item`}
					/>
				);
			})}
		</>
	);
}
